import { ResponsiveBar } from "@nivo/bar";
import { useTranslation } from "react-i18next";

// import { convertValueToLocale } from "helpers/convertValueToLocale";

import { InvestmentGraphic } from "components/InvestmentGraphicNew";

import { Typography } from "shared/ui/components/Typography";

import styles from "./InvestmetAnalysisChart.module.scss";

// import { chartSmallConfig } from "config/chart";

//TODO Не удалять, старые расчеты
// const _renderInfoPopover = ({ t, info }: { t: any; info: any }) => {
//   return (
//     <div className={styles.popover}>
//       <Typography variant="bodyS" weight="light">
//         {t("calculator_pro_page.property_value_chart.info_popover_title")}
//       </Typography>
//       {info.apartmentsPrices.map((item: any, index: number) => (
//         <div key={index}>
//           <div className={styles.popoverInfoItem}>
//             <Typography
//               variant="bodyS"
//               weight="semiBold"
//               className={styles.popoverInfoItemTitle}
//             >
//               {t(
//                 `calculator_pro_page.property_value_chart.info.apt_info_popover_title`
//               )}
//             </Typography>
//             <Typography
//               variant="bodyS"
//               weight="light"
//               className={styles.popoverInfoItemValue}
//             >
//               {convertValueToLocale(item.aptPrice)}
//             </Typography>
//           </div>
//           {item.aptFurniturePrice > 0 && (
//             <div className={styles.popoverInfoItem}>
//               <Typography
//                 variant="bodyS"
//                 weight="semiBold"
//                 className={styles.popoverInfoItemTitle}
//               >
//                 {t(
//                   `calculator_pro_page.property_value_chart.info.furniture_info_popover_title`
//                 )}
//               </Typography>
//               <Typography
//                 variant="bodyS"
//                 weight="light"
//                 className={styles.popoverInfoItemValue}
//               >
//                 {convertValueToLocale(item.aptFurniturePrice)}
//               </Typography>
//             </div>
//           )}
//         </div>
//       ))}
//       {info.parkingsPrices.map((item: any, index: number) => (
//         <div key={index} className={styles.popoverInfoItem}>
//           <Typography
//             variant="bodyS"
//             weight="semiBold"
//             className={styles.popoverInfoItemTitle}
//           >
//             {t(
//               `calculator_pro_page.property_value_chart.info.parking_info_popover_title`
//             )}
//           </Typography>
//           <Typography
//             variant="bodyS"
//             weight="light"
//             className={styles.popoverInfoItemValue}
//           >
//             {convertValueToLocale(item.parkingPrice)}
//           </Typography>
//         </div>
//       ))}
//       <div className={styles.popoverInfoItem}>
//         <Typography variant="bodyS" weight="light">
//           {t(
//             "calculator_pro_page.property_value_chart.info.info_popover_subtitle"
//           )}
//         </Typography>
//       </div>
//       {info.apartmentsPrices.map((item: any, index: number) => (
//         <div key={index} className={styles.popoverInfoItem}>
//           <Typography
//             variant="bodyS"
//             weight="semiBold"
//             className={styles.popoverInfoItemTitle}
//           >
//             {t(
//               `calculator_pro_page.property_value_chart.info.apt_info_popover_rate_title`
//             )}
//           </Typography>
//           <Typography
//             variant="bodyS"
//             weight="light"
//             className={styles.popoverInfoItemValue}
//           >
//             {t(
//               "calculator_pro_page.property_value_chart.info.apt_info_popover_rate_value",
//               {
//                 aptPriceGrowth: item.aptPriceGrowth,
//               }
//             )}
//           </Typography>
//         </div>
//       ))}
//       {info.parkingsPrices.map((item: any, index: number) => (
//         <div key={index} className={styles.popoverInfoItem}>
//           <Typography
//             variant="bodyS"
//             weight="semiBold"
//             className={styles.popoverInfoItemTitle}
//           >
//             {t(
//               `calculator_pro_page.property_value_chart.info.parking_info_popover_rate_title`
//             )}
//           </Typography>
//           <Typography
//             variant="bodyS"
//             weight="light"
//             className={styles.popoverInfoItemValue}
//           >
//             {t(
//               "calculator_pro_page.property_value_chart.info.parking_info_popover_rate_value",
//               {
//                 parkingPriceGrowth: item.parkingPriceGrowth,
//               }
//             )}
//           </Typography>
//         </div>
//       ))}
//     </div>
//   );
// };

const _renderInfoPopover = ({ info }: { info: any }) => {
  return (
    <div className={styles.popover}>
      <Typography variant="bodyS" weight="light">
        {info.section1}
      </Typography>
      {info.section2 && (
        <Typography
          variant="bodyS"
          weight="light"
          className={styles.popoverSection}
        >
          {info.section2}
        </Typography>
      )}
    </div>
  );
};

const InvestmetAnalysisChart = ({
  variant,
  earlySaleProfitConclusion,
}: {
  variant: string;
  earlySaleProfitConclusion: any;
}) => {
  const { t } = useTranslation();

  return (
    <InvestmentGraphic
      variant={variant}
      descriptionVariant={variant}
      title={t("calculator_pro_page.investmet_analysis_chart.title")}
      price={earlySaleProfitConclusion.price}
      caption={earlySaleProfitConclusion.caption}
      description={earlySaleProfitConclusion.description}
      details={earlySaleProfitConclusion.details}
      // infoPopover={_renderInfoPopover({ t, info: propertyValueChart.info })} //TODO Не удалять, старые расчеты
      infoPopover={_renderInfoPopover({ info: earlySaleProfitConclusion.info })}
    >
      <div className={styles.chart}>
        <ResponsiveBar
          data={earlySaleProfitConclusion.chartData}
          indexBy="chartItem"
          enableLabel
          enableGridY={false}
          labelSkipWidth={12}
          labelSkipHeight={12}
          axisBottom={null}
          axisLeft={null}
          colors={({ id, data }) => {
            return String(data[`${id}Color`]);
          }}
          labelPosition="end"
          labelOffset={10}
          labelTextColor="#131618"
          label={(labelItem: any) => {
            return labelItem.data.chartItem;
          }}
          tooltip={() => <></>}
          margin={{ top: 15, right: 0, bottom: 0, left: 0 }}
          theme={{
            labels: {
              text: {
                fontSize: 8,
                fontWeight: 500,
              },
            },
          }}
        />
      </div>
    </InvestmentGraphic>
  );
};

export default InvestmetAnalysisChart;
